// NPM Imports
import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import uuid from "react-native-uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Toastr, Button } from "@revvsales/components";

// Components Imports
import StatusDropdown from "../QuotationTopbar/StatusDropdown";

// Actions Imports
import {
  sendDocForApproval,
  fetchAndUpdateDocMeta,
  forceApproveDoc,
  analyzeDoc,
  tempUpdateDocMeta,
  approvalStatusCheck,
} from "../../actions/DocumentActions";
import { DealTableActions } from "../../actions";

// Internal Imports
import { EVENTS } from "../../constants";
import { AmplitudeUtils } from "../../utils";

// Destructuring
const { onDealTableSave } = DealTableActions;

class AnalysisPopup extends Component {
  state = {
    isLoading: true,
    comment: "",
    approvalEventUuid: "",
    showBtnLoader: false,
  };

  componentDidMount() {
    // To make stopEditingWhenGridLosesFocus event trigger first
    const { dealTable } = this.props;
    if (dealTable) {
      setTimeout(() => this._saveDTAndAnalyze(), 0);
    } else {
      this._analyzeDoc();
    }
  }

  _saveDTAndAnalyze = () => {
    this._analyzeDoc();
  };

  _analyzeDoc = () => {
    this.setState({ approvalEventUuid: uuid.v4() }, () =>
      this.props
        .analyzeDoc({
          event: "sent_for_approval",
          event_id: this.state.approvalEventUuid,
          entity: "DEAL",
          entity_id: this.props.docID,
        })
        .then(response => {
          const { Analysis } = response;
          // Check if there is no approval required then, show the "AddRecipientsPopup"
          if (Analysis && Analysis.length === 0) {
            this.props.toggleModalPopUp("showAnalysisModal", false);
            this.props.toggleModalPopUp(
              "showDocStatusUpdateModal",
              true,
              "forApproval",
            );
          }
          this.setState({ isLoading: false });
        })
        .catch(error => {
          console.error(`AnalysisPopup => _analyzeDoc => ${error}`);
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });
          this.setState({ isLoading: false });
          this.props.toggleModalPopUp("showAnalysisModal", false);
        }),
    );
  };

  _changeComment = e => {
    this.setState({ comment: e.target.value });
  };

  _sendDocForApproval = () => {
    const payload = {
      event_id: this.state.approvalEventUuid,
      entity: "DEAL",
      entity_id: this.props.docID,
      user_comment: this.state.comment,
    };

    this.setState({ showBtnLoader: true });
    this.props
      .sendDocForApproval(payload)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Document sent for Approval successfully",
          timeout: 1000,
        });
        this.props.toggleModalPopUp("showAnalysisModal", false);
        this.setState({ showBtnLoader: false });
        this.props.fetchAndUpdateDocMeta(this.props.docNo);
        this.props.approvalStatusCheck(this.props.docID);
      })
      .catch(() => {
        Toastr.showToastr({
          type: "failure",
          message: "Oops, Something went wrong!!",
          timeout: 3000,
        });
        this.setState({ showBtnLoader: false });
      });
  };

  _forceApproveDoc = () => {
    this.props.togglePopUp("showAnalysisModal", false);
    this.props
      .forceApproveDoc(this.props.docID)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Your document has been moved to the approved stage.",
          timeout: 1000,
        });
        this.props.fetchAndUpdateDocMeta(this.props.docNo);
      })
      .catch(() => {
        Toastr.showToastr({
          type: "failure",
          message: "Oops, Something went wrong!!",
          timeout: 3000,
        });
      });
  };

  _proceed = flag => {
    if (flag === "send") {
      this._sendDocForApproval();
      AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.INTERNAL_REVIEW, {
        ...this.props.doc,
        docAnalysis: this.props.docAnalysis,
      });
    } else if (flag === "force") {
      this._forceApproveDoc();
      AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.CUSTOMER_REVIEW, {
        ...this.props.doc,
      });
    }
  };

  _onProceed = stage => {
    const payload = {
      docIsLocked: true,
      stage,
    };

    this.props.tempUpdateDocMeta(payload);
    this.props.toggleModalPopUp("showAnalysisModal", false);
  };

  render() {
    if (this.state.isLoading) {
      return (
        <Loader
          className="saving-document"
          label="Analysing document"
          theme="dark"
          fullScreen
        />
      );
    }
    const { docAnalysis } = this.props;
    if (docAnalysis.length > 0) {
      return (
        <Modal
          open
          onClose={() =>
            this.props.toggleModalPopUp("showAnalysisModal", false)
          }
          closeOnOverlayClick={false}
          center>
          <div
            className="approvalpopup"
            id={`approvalpopup-${
              docAnalysis.length > 0 ? "needs-approval" : "no-approval"
            }`}>
            {/* {docAnalysis.length === 0 && (
              <div className="approved-doc-wrapper">
                <img
                  className="approved-doc"
                  src={approvedDoc}
                  alt="approved-doc"
                />
              </div>
            )} */}
            <div className="approvalpopup-modal-header">
              Your document requires approval
            </div>

            <Fragment>
              <div className="approvalpopup-workflows">
                <p className="approvalpopup-workflows-subheading">
                  The following users need to approve your document.
                </p>
                {docAnalysis.map(data => (
                  <Fragment>
                    <div className="approvalpopup-workflow-box" key={data.id}>
                      <div className="approvalpopup-workflow-box-reason">
                        <span>{data.triggeMessage}</span>
                      </div>
                      <div className="approvalpopup-workflow-box-title">
                        Approvers
                      </div>
                      {/* Groups Approvers Listing */}
                      <div className="approvalpopup-workflow-box-approver-row">
                        {data.groupApprovers.map(groupApprover => (
                          <div
                            className="approvalpopup-workflow-box-approver"
                            key={groupApprover.id}>
                            <span className="approvalpopup-workflowbox-groupapprovers-icon">
                              <FontAwesomeIcon icon={["far", "users"]} />
                            </span>
                            <span className="approvalpopup-workflow-box-approver-name">
                              {groupApprover.group_name || "-"}
                            </span>
                          </div>
                        ))}
                        {/* Approvers Listing */}
                        {data.approvers.map(approver => (
                          <div
                            className="approvalpopup-workflow-box-approver"
                            key={approver.id}>
                            <span className="approvalpopup-workflowbox-approverimg-wrapper">
                              <img
                                className="approvalpopup-workflowbox-approverimg"
                                src={approver.image_url}
                                alt="Approvar Profile"
                              />
                            </span>
                            <span className="approvalpopup-workflow-box-approver-name">
                              {approver.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Fragment>
                ))}
              </div>
              <div className="approvalpopup-note">
                <p className="approvalpopup-workflows-subheading">
                  Please add a comment to support your decision. (Recommended)
                </p>
                <textarea
                  rows="5"
                  value={this.state.comment}
                  onChange={e => this._changeComment(e)}
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                  data-test="analysispopup-textarea"
                />
              </div>
            </Fragment>

            {/* {docAnalysis.length === 0 && (
              <div className="approvalpopup-note">
                <p className="approvalpopup-workflows-subheading">
                  Your doc does not require any approval. It is ready to get
                  e-signed and sealed.
                </p>
              </div>
            )} */}

            {/* ----------- Update Document Status Section ----------- */}
            {this.props.showWhoHasAccessForRecipients && (
              <div className="docrecipientspopup-docstatus-wrapper">
                <div className="doc-status-lable">
                  <span>Also update document status to</span>
                </div>
                <div className="doc-status-select">
                  <StatusDropdown
                    currentStatus={this.props.documentStatus}
                    docId={this.props.docID}
                    currentTag={this.props.documentTag}
                    source="Popup"
                  />
                </div>
              </div>
            )}
          </div>
          <section className="createquotepopup-footer popup-footer clearfix">
            <div className="footer-actions">
              <Fragment>
                <Button
                  className="btn btn-transparent createquotepopup-footer-cancelbtn"
                  id="approvalpopup-needs-approval-cancel-btn"
                  onClick={() =>
                    this.props.toggleModalPopUp("showAnalysisModal", false)
                  }
                  data-test="analysispopup-review-btn">
                  Wait, let me review again
                </Button>
                <Button
                  className="btn btn-primary"
                  isLoading={this.state.showBtnLoader}
                  id="approvalpopup-needs-approval-ok-btn"
                  onClick={() => this._proceed("send")}
                  data-test="analysispopup-send-btn">
                  {/* onClick={() => this._onProceed("INTERNAL_REVIEW")}> */}
                  Yes, send for internal review
                </Button>
              </Fragment>
            </div>
          </section>
        </Modal>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  const {
    docAnalysis,
    document: doc,
    isDocFormValid,
    showWhoHasAccessForRecipients,
  } = state.DocumentStore;
  const { id: docID, docNo, dealTable, documentStatus, documentTag } = doc;
  return {
    docAnalysis,
    doc,
    docID,
    docNo,
    documentStatus,
    documentTag,
    isDocFormValid,
    dealTable,
    showWhoHasAccessForRecipients,
  };
};

const mapDispatchToProps = {
  onDealTableSave,
  tempUpdateDocMeta,
  analyzeDoc: data => analyzeDoc(data),
  sendDocForApproval: data => sendDocForApproval(data),
  forceApproveDoc: docID => forceApproveDoc(docID),
  fetchAndUpdateDocMeta: docNo => fetchAndUpdateDocMeta(docNo),
  approvalStatusCheck: (docID, status) => approvalStatusCheck(docID, status),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AnalysisPopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AnalysisPopup.js